import React from 'react';

const ROLE_LABEL = {
  showrunner: 'Showrunner',
  rundown: 'Producer',
  fact_desk: 'Scribe',
  writer: 'Quill',
  director: 'Frame',
  news_desk: 'Wire',
  stenographer: 'Stenographer',
  sensor_rollup: 'Delta',
};

export default function ProductionCrewStatusStrip({ crew }) {
  if (!crew || crew.length === 0) {
    return <div className="crew-strip" data-testid="crew-strip-empty" style={{ color: 'var(--studio-text-3)', fontSize: 11 }}>No crew agents reporting</div>;
  }
  return (
    <div className="crew-strip" data-testid="crew-strip">
      {crew.map((c) => {
        const cls = c.status === 'working' ? 'working' : c.status === 'blocked' ? 'blocked' : 'idle';
        return (
          <span
            key={c.name}
            className={`crew-pill ${cls}`}
            style={{ color: c.color || 'var(--studio-text-1)' }}
            data-testid={`crew-pill-${c.name}`}
            title={`${c.name} · ${c.status} · queue ${c.queue_depth}`}
          >
            <i className="dot" />
            {c.name.toUpperCase()}
            {c.queue_depth > 0 && (
              <span style={{
                marginLeft: 4, padding: '0 4px',
                background: 'var(--studio-bg-3)', color: 'var(--studio-text-0)',
                borderRadius: 1, fontSize: 9,
              }}>{c.queue_depth}</span>
            )}
          </span>
        );
      })}
    </div>
  );
}
